module.exports = __webpack_public_path__ + "static/tint-3-59f4c448dd56c7888c386999e18384aa.jpg";